module.exports = __webpack_public_path__ + "static/media/cross.a641a952.png";